import { ApiURL } from "../../setting/GlobleVariable";

const getCategoryMapping = (userCategory) => {
  const categoryMappings = {
    concerts: { id: "54", name: "Concerts", slug: "concerts", parent: null },
    music: { id: "54", name: "Concerts", slug: "concerts", parent: null },
    sports: { id: "1", name: "Sports", slug: "sports", parent: null },
    theater: { id: "68", name: "Theater", slug: "theater", parent: null },
    "arts-theater": { id: "68", name: "Theater", slug: "theater", parent: null },
    comedy: { id: "55", name: "Comedy", slug: "comedy", parent: null },
    festivals: { id: "73", name: "Festivals", slug: "festivals", parent: null },
    gaming: { id: "54", name: "Concerts", slug: "concerts", parent: null },
    conference: { id: "54", name: "Concerts", slug: "concerts", parent: null },
    art: { id: "54", name: "Concerts", slug: "concerts", parent: null },
    webinar: { id: "54", name: "Concerts", slug: "concerts", parent: null },
    workshop: { id: "54", name: "Concerts", slug: "concerts", parent: null },
    networking: { id: "54", name: "Concerts", slug: "concerts", parent: null },
    training: { id: "54", name: "Concerts", slug: "concerts", parent: null },
    other: { id: "54", name: "Concerts", slug: "concerts", parent: null },
  };
  return categoryMappings[userCategory] || categoryMappings.concerts;
};

export async function publishEvent(formData) {
  const eventDate = formData.startDate || new Date().toISOString().split("T")[0];
  const eventTime = formData.startTime || "00:00";
  // The organizer typed a wall-clock time where they are. Previously it was
  // stamped "Z" (UTC), so a 9 PM Los Angeles event was stored as 2 PM PT,
  // and the local stamp was hard-coded to -08:00 (wrong all summer).
  const localStart = new Date(`${eventDate}T${eventTime}:00`);
  const occursAtUtc = Number.isNaN(localStart.getTime())
    ? `${eventDate}T${eventTime}:00Z`
    : localStart.toISOString().replace(/\.\d{3}Z$/, "Z");
  const offMin = Number.isNaN(localStart.getTime()) ? 480 : localStart.getTimezoneOffset();
  const sign = offMin <= 0 ? "+" : "-";
  const abs = Math.abs(offMin);
  const offset = `${sign}${String(Math.floor(abs / 60)).padStart(2, "0")}:${String(abs % 60).padStart(2, "0")}`;
  let timeZone = "America/Los_Angeles";
  try {
    timeZone = Intl.DateTimeFormat().resolvedOptions().timeZone || timeZone;
  } catch (_) {}
  // A tier with no quantity is unlimited (the server treats 0 as "no cap").
  const UNLIMITED = 1000;
  const totalAvailableCount =
    formData.tickets?.reduce((sum, ticket) => sum + (parseInt(ticket.quantity, 10) || UNLIMITED), 0) || 0;
  const userEventId = Date.now() + Math.floor(Math.random() * 10000);

  const categoryData = getCategoryMapping(formData.category);
  const eventData = {
    id: userEventId,
    name: formData.eventTitle,
    occurs_at: occursAtUtc,
    occurs_at_local: `${eventDate}T${eventTime}:00${offset}`,
    venue: {
      id: userEventId + 1000,
      name: formData.venueName || formData.venueAddress || "TBD",
      location: [formData.venueCity, formData.venueState].filter(Boolean).join(", ") || formData.venueAddress || formData.eventLocation || "TBD",
      slug: (formData.venueName || "venue").toLowerCase().replace(/\s+/g, "-"),
      url: `/venues/${userEventId + 1000}`,
      time_zone: timeZone,
      address: {
        street_address: formData.venueAddress || "TBD",
        extended_address: "",
        // Real values only: these used to be "TBD", "CA", "00000" and a fixed
        // downtown-LA pin for every event, which broke maps and "near me".
        locality: formData.venueCity || "",
        region: formData.venueState || "",
        postal_code: formData.venueZip || "",
        country_code: "US",
        location: [formData.venueAddress, formData.venueCity, formData.venueState].filter(Boolean).join(", ") || formData.eventLocation || "TBD",
        latitude: formData.latitude ?? null,
        longitude: formData.longitude ?? null,
        label: null,
        created_at: new Date().toISOString(),
      },
    },
    category: {
      id: categoryData.id,
      name: categoryData.name,
      slug: categoryData.slug,
      url: `/categories/${categoryData.id}`,
      slug_url: `/categories/${categoryData.slug}`,
      parent: categoryData.parent,
    },
    configuration: {
      id: userEventId + 2000,
      url: `/configurations/${userEventId + 2000}`,
      name: "General Admission",
      fanvenues_key: null,
      ticket_utils_id: null,
      seating_chart: { medium: "null", large: "null" },
    },
    performances: [
      {
        performer: {
          id: userEventId + 3000,
          slug: "organizer",
          slug_url: "/performers/organizer",
          url: `/performers/${userEventId + 3000}`,
          name: "Event Organizer",
        },
        primary: true,
      },
    ],
    available_count: totalAvailableCount,
    products_count: totalAvailableCount,
    products_eticket_count: totalAvailableCount,
    long_term_popularity_score: 0.1,
    popularity_score: 0,
    promotion_label: null,
    state: "shown",
    tbd: false,
    owned_by_office: false,
    notes: formData.eventDescription || "",
    updated_at: new Date().toISOString(),
    url: `/events/${userEventId}`,
    requirements: {
      face_value_display: false,
      inclusive_pricing: true,
      seat_number_display: false,
    },
    _isUserCreated: true,
    userTickets: formData.tickets || [],
    description: formData.eventDescription || "",
    eventLink: formData.eventLink || "",
    // One-screen creator extras
    userCategory: formData.category || "",
    entryType: formData.entryType || "tickets",
    maxPlusOnes: parseInt(formData.maxPlusOnes, 10) || 0,
    coverTheme: formData.coverTheme || null,
    visibility: formData.eventVisibility || "public",
    endDate: formData.endDate || "",
    endTime: formData.endTime || "",
  };

  const apiFormData = new FormData();
  apiFormData.append("event", JSON.stringify([eventData]));
  apiFormData.append("isFeatured", formData.isFeatured || false);
  apiFormData.append("paragarph", formData.eventDescription || "");
  if (formData.eventImage) {
    apiFormData.append("file", formData.eventImage);
  }

  const res = await fetch(`${ApiURL}/event/create`, {
    method: "POST",
    headers: { token: localStorage.getItem("instapass_user_token") },
    body: apiFormData,
  });
  const data = await res.json().catch(() => ({}));

  if (res.status === 500) throw new Error("Internal Server Error");
  if (!res.ok || data?.success === false) {
    const err = new Error(data?.message || "Failed to create event");
    err.code = data?.code;
    throw err;
  }
  return data;
}

export const EVENT_CREATION_FEE = 50;
